// Tags universais de reclamacao (mantenha em sincronia com /app/backend/config.py
// e /app/frontend/src/pages/FeedbackForm.jsx).
// Ao alterar aqui, valide tambem em FeedbackForm e SettingsBrandTab.

export const DEFAULT_COMPLAINT_TAGS = {
  atendimento: [
    'Demora no Atendimento',
    'Falta de Conhecimento sobre Produto/Serviço',
    'Falta de Atenção',
    'Erro no Pedido / Serviço',
    'Atendimento Grosseiro',
  ],
  produto: [
    'Não Atendeu Expectativa',
    'Produto com Defeito',
    'Produto em Falta',
    'Apresentação Visual',
    'Custo-Benefício',
  ],
  ambiente: [
    'Limpeza / Higiene',
    'Temperatura / Clima',
    'Barulho / Acústica',
    'Conforto / Estrutura',
    'Organização / Sinalização',
  ],
};

/**
 * Resolve as tags ativas de uma categoria considerando customizacao da empresa.
 * Se a empresa configurou custom_tags_<categoria>, usa elas; senao usa o default universal.
 * Aceita variantes legadas sem acento para compatibilidade com avaliacoes antigas.
 */
export function resolveCategoryTags(category, companySettings) {
  const customKey = `custom_tags_${category}`;
  const custom = companySettings?.[customKey];
  if (Array.isArray(custom) && custom.length > 0) return custom;
  return DEFAULT_COMPLAINT_TAGS[category] || [];
}

/**
 * Para um conjunto de tags vindas do backend, mapeia cada uma para sua categoria.
 * Tags desconhecidas (nem nas listas default nem nas customizadas) caem em "outras".
 */
export function categorizeTagStats(tagStats, companySettings) {
  const tagsAtendimento = resolveCategoryTags('atendimento', companySettings);
  const tagsProduto = resolveCategoryTags('produto', companySettings);
  const tagsAmbiente = resolveCategoryTags('ambiente', companySettings);

  // Normalizador resiliente: permite casamento mesmo com diferenca de acentos / espacos
  const norm = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  const setA = new Set(tagsAtendimento.map(norm));
  const setP = new Set(tagsProduto.map(norm));
  const setM = new Set(tagsAmbiente.map(norm));

  const buckets = {
    atendimento: { label: 'Atendimento', color: 'from-orange-400 to-orange-600', tags: [] },
    produto: { label: 'Produto', color: 'from-red-400 to-red-600', tags: [] },
    ambiente: { label: 'Ambiente', color: 'from-violet-400 to-violet-600', tags: [] },
    outras: { label: 'Outras', color: 'from-slate-400 to-slate-600', tags: [] },
  };

  for (const t of (tagStats || [])) {
    const n = norm(t.tag);
    if (setA.has(n)) buckets.atendimento.tags.push(t);
    else if (setP.has(n)) buckets.produto.tags.push(t);
    else if (setM.has(n)) buckets.ambiente.tags.push(t);
    else buckets.outras.tags.push(t);
  }

  // Ordenar tags em cada bucket por count desc
  Object.values(buckets).forEach(b => b.tags.sort((a, b2) => (b2.count || 0) - (a.count || 0)));
  return buckets;
}
